<template>
  <div class="box" v-loading="loading2"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <p class="paytip">需支付：{{sl}} {{bz}}</p>
    <p class="warning">请注意：若充值非{{bz}}资产，不可找回</p>
    <p class="paytip2">请向下方地址转账</p>
    <p class="payparice">{{sl}} {{bz}}</p>
    <img v-bind:src="qrcode"  class="addresqrcode"/>
    <div class="addres">{{walletAddress}}</div>
    <div class="button_box">
      <a v-clipboard:copy="walletAddress"  v-clipboard:success="onCopy"  v-clipboard:error="onError">复制收款地址</a>
      <a>长按二维码保存</a>
    </div>
    <a  class="downloadButton" @click="goPayHistroy">已转账</a>
    <div class="successTip" v-if="TipStutas">
      {{TipStutasText}}
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'waitPay',
  created: function () {
    if (this.$route.query.walletAddress) {
      this.token = this.$route.query.token
      this.uuid = this.$route.query.uuid
      this.uid = this.$route.query.uid
      this.bz = this.$route.query.bz
      this.sl = this.$route.query.sl
      this.viptype = this.$route.query.viptype
      this.walletAddress = this.$route.query.walletAddress
      QRCode.toDataURL(this.$route.query.walletAddress, { errorCorrectionLevel: 'H' })
        .then(url => {
          this.qrcode = url
          console.log(url)
        })
        .catch(err => {
          console.error(err)
        })
    }
  },
  data () {
    return {
      token: '',
      uuid: '',
      uid: '',
      bz: '',
      sl: '',
      viptype: '',
      walletAddress: '',
      TipStutas: false,
      TipStutasText: '',
      qrcode: '',
      loading2: false
    }
  },
  methods: {
    saveImage: function () {

    },
    goPayHistroy: function () {
      this.loading2 = true
      this.openmessage('转账进度和您支付的gass费有关,请耐心等待')
      window.wx.miniProgram.redirectTo({
        url: '/pages/gobay/buylist/buylist'
      })
      this.loading2 = false
    },
    openmessage: function (msg) {
      let _this = this
      this.TipStutasText = msg
      this.TipStutas = true
      setTimeout(function () {
        _this.TipStutasText = ''
        _this.TipStutas = false
      }, 2000)
    },
    onCopy: function () {
      this.openmessage('复制成功')
    },

    onError: function () {
      this.openmessage('复制失败')
    }
  }
}
</script>

<style scoped>
  .box{
    background-image: url('http://images.growup.link/assts/image/backgroundZTx1.png');
    width: 100%;
    height: 21.893rem;
    background-size: 100%;
  }
  .bottom_box{
    width: 100%;
    height: 3.04rem;
    position: fixed;
    bottom: 0px;
    left: 0px;
    background: rgba(16,31,49,0.60);
    box-shadow: 0 -1px 1px 0 #061629;
  }
  .downloadButton{
    font-family: PingFangSC-Regular;
    font-size: 0.373rem;
    color: #744A05;
    text-align: center;
    background-image: linear-gradient(-165deg, #FCEF22 0%, #FFDA28 100%);
    border-radius: 1.333rem;
    width: 7.467rem;
    height: 1.333rem;
    display: block;
    position: absolute;
    top: 13.05333rem;
    line-height: 1.333rem;
    transform: translateX(-50%);
    left: 50%;
    z-index: 3;
  }
  .downloadButtonShadow{
    position: absolute;
    z-index: 2;
    width: 7.467rem;
    height: 1.733rem;
    left: 50%;
    transform: translateX(-50%);
    top: 0.467rem;
    border-radius: 1.3333rem;
  }
  .paytip{
    font-family: PingFangSC-Regular;
    font-size: 0.48rem;
    color: #FFFFFF;
    position: absolute;
    left: 0.413rem;
    top: 0.293rem;
  }
  .paytip2{
    font-family: PingFangSC-Regular;
    font-size: 0.4rem;
    color: #FFFFFF;
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 2.267rem;
  }
  .payparice{
    font-family: PingFangSC-Regular;
    font-size: 0.8rem;
    color: #F5A623;
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 2.987rem;
  }
  .addresqrcode{
    width: 4.5rem;
    height: 4.5rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 4.447rem;
  }
  .addresqrcode canvas {
    width: 100% !important;
    height: 100% !important;
  }
  .addres{
    width: 6.4rem;
    font-family: PingFangSC-Regular;
    font-size: 0.373rem;
    color: #6E7E91;
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    word-wrap: break-word;
    top: 9.5rem;
  }
  .button_box{
    width: 7.413rem;
    height: 1.2rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 11rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .button_box a{
    box-sizing: border-box;
    display: block;
    width: 3.333rem;
    border-radius: 0.6rem;
    height: 1.2rem;
    border: 0.026rem solid #FFFFFF;
    font-family: PingFangSC-Medium;
    font-size: 0.426rem;
    line-height: 1.2rem;
    color: #FFFFFF;
    text-align: center;
  }
  .warning{
    font-family: PingFangSC-Regular;
    font-size: 0.373rem;
    color: #F5A623;
    letter-spacing: 0;
    line-height: 0.587rem;
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    position: absolute;
    left: 0.413rem;
    top: 1.053rem;
  }
  .warning>span{
    width: 0.533rem;
    height: 0.533rem;
    background-image: url("/static/warning.png");
    background-size: 100%;
    display: block;
  }
  .successTip{
    opacity: 0.8;
    background: #000000;
    border-radius: 0.267rem;
    position: fixed;
    top: 7.147rem;
    left: 50%;
    transform: translateX(-50%);
    height: 2.66667rem;
    width: 5.333rem;
    font-family: PingFangSC-Regular;
    font-size: 0.427rem;
    color: #FFFFFF;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 1000
  }
</style>



// WEBPACK FOOTER //
// src/components/waitPay.vue